import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { ConfigService } from '../../services/config.service';
import { formatString } from '../../utils/string-utils';

@Injectable({
	providedIn: 'root'
})
export class LogsService {

	constructor(
		private configService: ConfigService,
		private http: HttpClient
	) { }

	async getLogs(id: number = 0, type: string, page: number = 1, paging: any = {}, constraints: any = {}): Promise<any> {
		let url = formatString(this.configService.getConfig().dx.logsURL, type, id);
		url += `?page=${page}`;
		url += `&size=${paging.elementsPerPage}`;
		url += `&sort=${paging.sorting.sort}`;
		url += `&constraints=${encodeURIComponent(JSON.stringify(constraints))}`;

		try {
			const response = await firstValueFrom(this.http.get<any>(url, {}));

			if (response?.content) {
				let logs = response.content;
				logs.forEach((log: any) => {
					this.formatLogEvent(log);
				});
				return response;
			} else {
				return Promise.reject(false);
			}
		} catch (error) {
			return Promise.reject(error);
		}
	}

	private formatLogEvent(log: any) {
		if (!log) return;
		var created = new Date(log.eventDate);
		log.eventDateStr = created.toLocaleDateString('en-US') + ' ' + created.toLocaleTimeString('en-US');
		if (log.eventType) {
			log.eventTypeStr = log.eventType.displayname;
		}
		if (log.message) {
			log.message.durationString = this.getTime(log.message.duration);
		}
	}

	private getTime(milli: number): string {
		if (!milli) return "";
		var time = new Date(milli);
		var hours = time.getUTCHours();
		var minutes = time.getUTCMinutes();
		var seconds = time.getUTCSeconds();
		return hours + ":" + minutes + ":" + seconds;
	}

	formatLogsAsCSV(logs: any) {
		var quotify = function(input: any) {
			return '"' + input + '"';
		}

		var content = 'Date,Event,Product,Message,Duration\n';

		logs.forEach((log: any) => {
			var data = [];
			data.push(
				quotify(log.eventDateStr),
				quotify(log.eventTypeStr),
				quotify(log.documentTitle),
				quotify(log.message.messageText),
				quotify(log.message.durationString)
			);
			content += data.join(',') + "\n";
		});
		return content;
	}
}
